import { app, mouse } from "../utils/store"
import { mouseCurrentPosition } from "../utils/dom"

import gsap from 'gsap'
import each from 'lodash/each'

class Cursor {
    constructor() { 
        if(app.device.desktop){ app.cursor = this }
        
    }
    
    create() {
        this.interactive = {
            links: document.querySelectorAll('a'),
            buttons: document.querySelectorAll('button'),
            inputs: document.querySelectorAll('input, textarea'),
            carousels: document.querySelectorAll('[data-carousel]'),
            arrow: document.querySelectorAll('[data-arrow]'),
        }
        
        // this.timeline = {
        //     in: gsap.timeline({ paused: true, defaults: {duration: 1, ease: "linear"} }),
        //     out: gsap.timeline({ paused: true, defaults: {duration: 1, ease: "linear"} }),
        // }


        if(!document.getElementById('cursor')){ this.createCursor() } // Create Cursor only if NOT exists
    }

    createCursor(){
        let cursor = document.createElement('div')
        // let figure = new Image()

        cursor.id = 'cursor'
        cursor.setAttribute('data-label-default','')
        cursor.setAttribute('data-label','')

        // figure.classList = 'cursor--figure'
        // figure.alt = ''
        // cursor.append(figure)
        app.cursor = cursor
        app.html.prepend(app.cursor)

        this.followMouse(cursor)

        each(this.interactive, (entry) => {
            each(entry, (subentry) => this.hoverState(subentry) )
        })

        // if(this.interactive.links){ this.hoverState(this.interactive.links) }
        // if(this.interactive.buttons){ this.hoverState(this.interactive.buttons) }
        // if(this.interactive.carousels){ this.hoverState(this.interactive.carousels) }
        // if(this.interactive.arrow){ this.hoverState(this.interactive.arrow) }
        // if(this.interactive.cta){ this.hoverState(this.interactive.cta) }
        // if(this.interactive.slide){ this.hoverState(this.interactive.slide) }
    }

    followMouse = (element) => {
        gsap.set(element, {
            xPercent: -50, 
            yPercent: -50
        })

        var position = { 
            x: window.innerWidth / 2, 
            y: window.innerHeight / 2 
        }

        mouse.x = position.x
        mouse.y = position.y 

        var speed = 0.1

        var fpms = 60 / 1000

        var xSet = gsap.quickSetter(element, "x", "px")
        var ySet = gsap.quickSetter(element, "y", "px")

        window.addEventListener("mousemove", (event) => {
            mouse.x = event.clientX
            mouse.y = event.clientY
        })

        gsap.ticker.add((time, deltaTime) => {
            var delta = deltaTime * fpms
            var dt = 1.0 - Math.pow(1.0 - speed, delta) 
            
            position.x += (mouse.x - position.x) * dt
            position.y += (mouse.y - position.y) * dt

            xSet(position.x)
            ySet(position.y)
        })
    }

    addEventListeners = () => {
        each(this.interactive, (entry) => { this.onMouseUp(entry) })
        each(this.interactive, (entry) => { this.onMouseDown(entry) })
        each(this.interactive, (entry) => { this.onMouseEnter(entry) })
        each(this.interactive, (entry) => { this.onMouseLeave(entry) })
    }

    onMouseEnter = (array) => {
        each(array.entries, (entry) => {
            let elementLabel = entry.getAttribute('data-label')
            let elementIcon = entry.getAttribute('data-icon')
            let isLink = entry.href != null
            let isButton = entry.localName == 'button'
            let isCarousel = entry.hasAttribute('data-carousel')
            let isArrow = entry.hasAttribute('data-arrow')
    
            entry.addEventListener('mouseover', (e) => { 
                if(elementLabel){ cursor.setAttribute('data-label', elementLabel) }
                if(elementIcon){ cursor.setAttribute('data-icon', elementIcon) }
                if(isCarousel){ cursor.classList.add('drag') }
                if(isArrow){ 
                    cursor.classList.add('arrow')
                    if(entry.hasAttribute('data-prev')){ cursor.classList.add('reverse') }
                }
                if(isLink || isButton){
                    e.stopPropagation()
                    cursor.classList.remove('arrow')
                    cursor.classList.remove('drag')
                }
                cursor.classList.add('active') 
            })
        })
    }

    onMouseLeave = (array) => {
        each(array.entries, (entry) => {
            let elementLabel = entry.getAttribute('data-label')
            let elementIcon = entry.getAttribute('data-icon')
            let isLink = entry.href != null
            let isButton = entry.localName == 'button'
            let isCarousel = entry.hasAttribute('data-carousel')
            let isArrow = entry.hasAttribute('data-arrow')

            entry.addEventListener('mouseover', (e) => { 
                if(elementLabel){ cursor.setAttribute('data-label', elementLabel) }
                if(elementIcon){ cursor.setAttribute('data-icon', elementIcon) }
                if(isCarousel){ cursor.classList.add('drag') }
                if(isArrow){ 
                    cursor.classList.add('arrow')
                    if(entry.hasAttribute('data-prev')){ cursor.classList.add('reverse') }
                }
                if(isLink || isButton){
                    e.stopPropagation()
                    cursor.classList.remove('arrow')
                    cursor.classList.remove('drag')
                }
                cursor.classList.add('active') 
            })
        })
    }

    onMouseDown = (array) => {
        each(array.entries, (entry) => {
            cursor.classList.add('click') 
            cursor.classList.remove('closer') 
        })
    }

    onMouseUp = (array) => {
        each(array.entries, (entry) => { cursor.classList.remove('click') })
    }

    hoverState = (entry) => {
        let elementLabel = entry.getAttribute('data-label')
        let elementIcon = entry.getAttribute('data-icon')
        let isLink = entry.href != null
        let isButton = entry.localName == 'button'
        let isCarousel = entry.hasAttribute('data-carousel')
        let isArrow = entry.hasAttribute('data-arrow')


        entry.onmouseover = (event) => { 
            if(elementLabel){ app.cursor.setAttribute('data-label', elementLabel) }
            if(elementIcon){ app.cursor.setAttribute('data-icon', elementIcon) }
            if(isCarousel){  app.cursor.classList.add('drag') }
            if(isArrow){ 
                app.cursor.classList.add('arrow')
                if(entry.hasAttribute('data-prev')){ app.cursor.classList.add('reverse') }
            }
            if(isLink || isButton){
                event.stopPropagation()
                app.cursor.classList.remove('arrow')
                app.cursor.classList.remove('drag')
            }
            app.cursor.classList.add('active') 
        }

        entry.onmouseleave = (event) => { 
            if(elementLabel){ app.cursor.setAttribute('data-label', elementLabel) }
            if(elementIcon){ app.cursor.setAttribute('data-icon', elementIcon) }
            if(isCarousel){  app.cursor.classList.remove('drag') }
            if(isArrow){ 
                app.cursor.classList.remove('arrow')
                if(entry.hasAttribute('data-prev')){ app.cursor.classList.remove('reverse') }
            }
            if(isLink || isButton){
                event.stopPropagation()
                app.cursor.classList.remove('arrow')
                app.cursor.classList.remove('drag')
            }
            app.cursor.classList.remove('active') 
        }

        entry.onmousedown = (event) => { 
            app.cursor.classList.remove('click') 
            app.cursor.classList.remove('closer') 
        }

        entry.onmouseup = (event) => { app.cursor.classList.remove('click') }
    }

    update = () => {
        if(app.cursor){
            this.interactive = {
                links: document.querySelectorAll('a'),
                buttons: document.querySelectorAll('button'),
                inputs: document.querySelectorAll('input, textarea'),
                carousels: document.querySelectorAll('[data-carousel]'),
                arrow: document.querySelectorAll('[data-arrow]'),
            }
            
            each(this.interactive, (entry) => {
                each(entry, (subentry) => this.hoverState(subentry))
            })
        }
    }

    destroy = () => { 
        
    }
}

export const CursorManager = new Cursor()